import { createContext } from 'react';
import type { CompletionResource, SchemaAnnotations } from '../lib/expressions';

/** What `${...}` completion can offer in the current designer: parameters and other resources' outputs. */
export interface CompletionSource {
  parameters: string[];
  resources: CompletionResource[];
  /** Declared secret names. */
  secrets?: string[];
}

export const CompletionSourceContext = createContext<CompletionSource>({
  parameters: [],
  resources: [],
  secrets: [],
});

/** Annotations of the schema field being rendered, provided by the field template to its widget. */
export const FieldAnnotationsContext = createContext<SchemaAnnotations | null>(null);
